/**
 * ZIP Code to State Lookup
 * Lightweight lookup for US ZIP codes to state abbreviations
 * Usage: window.KivaZipLookup.getState('90210') returns 'CA'
 */

window.KivaZipLookup = (function() {
  // ZIP code ranges mapped to states
  const zipRanges = {
    'AL': [[35000, 36999]],
    'AK': [[99500, 99999]],
    'AZ': [[85000, 86999]],
    'AR': [[71600, 72999], [75502, 75505]],
    'CA': [[90000, 96699]],
    'CO': [[80000, 81999]],
    'CT': [[6000, 6999]],
    'DE': [[19700, 19999]],
    'FL': [[32000, 34999]],
    'GA': [[30000, 31999], [39800, 39999]],
    'HI': [[96700, 96899]],
    'ID': [[83200, 83999]],
    'IL': [[60000, 62999]],
    'IN': [[46000, 47999]],
    'IA': [[50000, 52999]],
    'KS': [[66000, 67999]],
    'KY': [[40000, 42999]],
    'LA': [[70000, 71599]],
    'ME': [[3900, 4999]],
    'MD': [[20600, 21999]],
    'MA': [[1000, 2799], [5501, 5544]],
    'MI': [[48000, 49999]],
    'MN': [[55000, 56799]],
    'MS': [[38600, 39999]],
    'MO': [[63000, 65999]],
    'MT': [[59000, 59999]],
    'NE': [[68000, 69999]],
    'NV': [[88900, 89999]],
    'NH': [[3000, 3899]],
    'NJ': [[7000, 8999]],
    'NM': [[87000, 88499]],
    'NY': [[10000, 14999]],
    'NC': [[27000, 28999]],
    'ND': [[58000, 58999]],
    'OH': [[43000, 45999]],
    'OK': [[73000, 74999]],
    'OR': [[97000, 97999]],
    'PA': [[15000, 19699]],
    'RI': [[2800, 2999]],
    'SC': [[29000, 29999]],
    'SD': [[57000, 57999]],
    'TN': [[37000, 38599]],
    'TX': [[75000, 79999], [73301, 73301], [88500, 88599]],
    'UT': [[84000, 84799]],
    'VT': [[5000, 5999]],
    'VA': [[20100, 20199], [22000, 24699]],
    'WA': [[98000, 99499]],
    'WV': [[24700, 26999]],
    'WI': [[53000, 54999]],
    'WY': [[82000, 83199]]
  };

  function getState(zipCode) {
    // Clean the ZIP code (remove spaces, dashes, and convert to number)
    const zip = parseInt(zipCode.toString().replace(/\D/g, '').substring(0, 5));

    if (isNaN(zip)) {
      return null;
    }

    // Check each state's ranges
    for (const [state, ranges] of Object.entries(zipRanges)) {
      for (const [min, max] of ranges) {
        if (zip >= min && zip <= max) {
          return state;
        }
      }
    }

    return null; // ZIP code not found
  }

  function isValidZip(zipCode) {
    const cleaned = zipCode.toString().replace(/\D/g, '');
    return cleaned.length === 5 && getState(cleaned) !== null;
  }

  return {
    getState: getState,
    isValidZip: isValidZip
  };
})();
